import React from "react";
import PropTypes from "prop-types";

export default class Alert extends React.Component{
    render(){
        return(
            <React.Fragment>
                {this.props.visible && (
                    <div className={`alert ${this.props.className}`} role="alert">
                        {this.props.children}
                    </div>
                )}
            </React.Fragment>
        );
    }
}

Alert.defaultProps = {
    className: "alert-primary"
};

Alert.propTypes = {
    visible: PropTypes.bool.isRequired,
    className: PropTypes.string,
    children: PropTypes.any
};
